module.exports = __webpack_public_path__ + "static/media/close.4dc8ead0.svg";